import React from 'react';
import { Modal } from "antd";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import Api from '../../../core/data/redux/utils/apiCall';
import { API_URLS } from '../../../core/data/redux/apis/urls';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Preloader from '../../../core/common/loader/preLoader';

import { isSupportViewer } from '../../../utils/permissionUtils';

const emailSchema: Yup.ObjectSchema<{ email: string }> = Yup.object({
    email: Yup.string()
        .required("Email is required")
        .email("Email must be a valid email address"),
});

const phoneSchema: Yup.ObjectSchema<{ phone_number: string }> = Yup.object({
    phone_number: Yup.string()
        .required("Phone is required")
        .max(10, "Phone number must be at most 10 digits")
        .matches(/^[0-9]+$/, "Phone must be numeric"),
});

interface SettingTestProps {
    type: string;
}

const SettingTest = ({ type }: SettingTestProps) => {
    const [showModal, setShowModal] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);

    // Choose schema dynamically
    const schemas: Record<string, Yup.ObjectSchema<any>> = {
        smtp: emailSchema,
        sms: phoneSchema,
    };

    const selectedSchema = schemas[type] || Yup.object({});

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(selectedSchema),
    });

    if (isSupportViewer()) return null;

    const onSubmit = (data: any) => {
        console.log("Submitted data:", data);
        testSetting(data)
    };


    const testSetting = async (paylaod: any) => {
        try {
            setIsLoading(true);
            const endPoint = type === 'sms' ? API_URLS.TEST_SMS_SETTINGS : type === 'smtp' ? API_URLS.TEST_SMTP_SETTINGS : API_URLS.TEST_STORAGE_SETTINGS;
            const response = await Api.post(`${endPoint}`, paylaod);
            setIsLoading(false);
            toast.success(response.data.message);
            setShowModal('');
        } catch (error: any) {
            setIsLoading(false);
            const errorMessage = error?.response?.data?.data?.message || 'Failed to fetch data.';
            toast.error(errorMessage);
        }
    }

    return (
        <div>
            {isLoading && <Preloader />}
            {type === 'storage' ? <button
                type="button"
                className="btn btn-primary w-100"
                style={{ textTransform: 'capitalize' }}
                onClick={() => testSetting(type || '')}
            >
                Test {type} Setting
            </button>
                : <button
                    type="button"
                    className="btn btn-primary w-100"
                    style={{ textTransform: 'capitalize' }}
                    onClick={() => setShowModal(type || '')}
                >
                    Test {type} Setting
                </button>
            }

            <Modal
                title={`Verify ${type.charAt(0).toUpperCase() + type.slice(1)} Setting`}
                open={showModal === type}
                onCancel={() => setShowModal('')}
                footer={false}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        {type === 'smtp' && (
                            <>
                                <label>Email</label>
                                <input className="form-control" {...register('email')} />
                                {typeof errors.email?.message === 'string' && (
                                    <div className="text-danger">{errors.email.message}</div>
                                )}
                            </>
                        )}
                        {type === 'sms' && (
                            <>
                                <label>Phone</label>
                                <input className="form-control" {...register('phone_number')} />
                                {typeof errors.phone_number?.message === 'string' && (
                                    <div className="text-danger">{errors.phone_number.message}</div>
                                )}
                            </>
                        )}
                    </div>
                    <button type="submit" className="btn btn-success">Submit</button>
                </form>
            </Modal>
        </div>
    );
};

export default SettingTest;
